import { env } from "@src/env";
const URL = {
  HOST: {
    production: "//cps-gateway.hortorgames.com",
    test: "//cps-gateway-test.hortorgames.com",
    development: "//cps-gateway-dev.hortorgames.com",
    // "development": "//10.1.1.50:39003",
  },
  miniHOST: {
    production: "",
    test: "",
    development: "",
  },
};
const url = {};

let key = env;
// key = "production"; //TODO 本地替换环境变量
console.log("=========");
console.log("env", key);
console.log("=========");

for (let k in URL) {
  url[k] = URL[k][key];
}

export default url;
